import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiPageAdapter, Page, PagedApiResponse } from '@fmnts/api/shared';
import { ApiConfigService } from '@fmnts/api/util';
import { Observable, map } from 'rxjs';
import { ApiNextQuizAdapter } from '../adapter/next-quiz.adapter';
import { IApiNextQuiz } from '../api-model/quiz.api';
import { NextQuiz } from '../model/quiz';

@Injectable({ providedIn: 'root' })
export class QuizNextApi {
  public static readonly rootUrl = '/api/next/v1/trainingcenter/quizzes';

  private readonly _fromApiNextQuizAdapter = new ApiNextQuizAdapter();
  private readonly _fromApiNextQuizPageAdapter = new ApiPageAdapter(
    this._fromApiNextQuizAdapter,
  );

  constructor(
    private http: HttpClient,
    private configService: ApiConfigService,
  ) {}

  /**
   * Fetches a list of quizzes
   *
   * @returns a paginated list of quizzes, including the status for attempts
   */
  public list(): Observable<Page<NextQuiz>> {
    const url = this.configService.buildApiUrl([QuizNextApi.rootUrl]);

    return this.http
      .get<PagedApiResponse<IApiNextQuiz>>(url)
      .pipe(
        map((response) => this._fromApiNextQuizPageAdapter.adapt(response)),
      );
  }

  /**
   * Fetch a quiz using `quiz.id`
   *
   * @param id The id of the quiz
   * @returns A quiz, including the status for attempts
   */
  public get(id: string): Observable<NextQuiz> {
    const url = this.configService.buildApiUrl([QuizNextApi.rootUrl, id]);

    return this.http
      .get<IApiNextQuiz>(url)
      .pipe(map((response) => this._fromApiNextQuizAdapter.adapt(response)));
  }
}
